var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95995 4.83999L5.15995 3.04999L3.74995 4.45999L5.53995 6.24999L6.95995 4.83999ZM4.19995 10.5H1.19995V12.5H4.19995V10.5ZM13.2 0.549988H11.2V3.49999H13.2V0.549988ZM20.65 4.45999L19.24 3.04999L17.45 4.83999L18.86 6.24999L20.65 4.45999ZM17.44 18.16L19.23 19.96L20.64 18.55L18.84 16.76L17.44 18.16ZM20.2 10.5V12.5H23.2V10.5H20.2ZM12.2 5.49999C8.88995 5.49999 6.19995 8.18999 6.19995 11.5C6.19995 14.81 8.88995 17.5 12.2 17.5C15.51 17.5 18.2 14.81 18.2 11.5C18.2 8.18999 15.51 5.49999 12.2 5.49999ZM11.2 22.45H13.2V19.5H11.2V22.45ZM3.74995 18.54L5.15995 19.95L6.94995 18.15L5.53995 16.74L3.74995 18.54Z",
    fill: "#FF6E04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolar);
export default __webpack_public_path__ + "static/media/solar.19e63d1027147d4bd579886a62400e78.svg";
export { ForwardRef as ReactComponent };